import clsx from 'clsx'

import { useState, useRef, useEffect } from 'react'

import { getVideoUrl } from 'shared-functions/utils'

import Play from '../../../images/play2'

import s from './VideoGallery.module.sass'

function Slide({ item, index, activeIndex, setActiveIndex }: any) {
    const videoRef = useRef<HTMLVideoElement>(null)

    const [isPlaying, setIsPlaying] = useState(false)

    const { title, copy, videoFile, image } = item

    const videoUrl = getVideoUrl(videoFile, null)
    const imageUrl = image?.asset?.url

    const togglePlay = () => {
        if (videoRef.current) {
            setIsPlaying((prev) => !prev)
            if (isPlaying) {
                videoRef.current.pause()
            } else {
                setTimeout(() => {
                    if (videoRef.current) {
                        videoRef.current.play().catch((error) => {
                            console.error('Error attempting to play', error)
                        })
                        setIsPlaying(true)
                    }
                }, 100)
            }
        }
    }

    useEffect(() => {
        if (videoRef.current) {
            videoRef.current.pause()
            videoRef.current.currentTime = 0
            setIsPlaying(false)
        }
    }, [activeIndex])

    // const handleClick = () => {
    //     console.log('Slide clicked:', index)
    //     if (sliderRef && sliderRef.current && typeof sliderRef.current.slideTo === 'function') {
    //         console.log('Navigating to slide:', index, sliderRef.current)
    //         sliderRef.current.slideTo(index)
    //     }
    // }

    return (
        <div className={clsx(s.Slide, activeIndex === index && s.Active)} onClick={() => setActiveIndex(index)}>
            <div className={s.Main}>
                <div className={s.PlayCont} onClick={togglePlay}>
                    <div className={clsx(s.Play, isPlaying && s.Playing)}>
                        {Play}
                    </div>
                </div>
                {imageUrl && (
                    <img
                        src={imageUrl}
                        alt={title || 'Video thumbnail'}
                        className={clsx(s.Poster, isPlaying && s.Hidden)}
                    />
                )}
                {videoUrl && (
                    <video
                        src={videoUrl}
                        loop
                        autoPlay={false}
                        playsInline
                        controls={false}
                        poster={imageUrl}
                        ref={videoRef}
                    />
                )}
            </div>
            <div className={s.Details}>
                <h4 dangerouslySetInnerHTML={{ __html: title }} />
                {copy &&
                    <span className="smallCaps" dangerouslySetInnerHTML={{ __html: copy }} />
                }
            </div>
        </div>
    )
}

export default Slide
